import { MilestoneDateEditor } from "@/containers/Project/components";
import * as S from "@/containers/Project/components/styled";
import { ProjectUserPermissions } from "@/enums";
import { findTargetMilestoneRecursive } from "@/helpers";
import { projectMilestoneType } from "@/propTypes";
import * as GlobalS from "@/sharedStyled";
import _ from "lodash";
import { func, object } from "prop-types";
import { useConfigurationQuery } from "@/services/appConfig";

const DATE_TYPE = {
  actual: "actualDate",
  target: "targetDate",
};

export const MilestoneDates = ({
  milestone,
  canUser,
  project,
  setProject,
}) => {

  const { data: configuration, isError } = useConfigurationQuery(
    {},
    { pollingInterval: 30000, refetchOnMountOrArgChange: true },
  );

  const keyMilestonesEnabled =
    !isError && configuration?.keyMilestoneDashboardEnabled === true;

  const updateProjectContext = (
    { milestoneId, date, actualDate },
    dateType
  ) => {
    const updatedProject = _.cloneDeep(project);

    for (const schedule of updatedProject.schedules) {
      const targetMilestone = findTargetMilestoneRecursive(
        schedule.milestones,
        milestoneId
      );

      if (targetMilestone) {
        targetMilestone[dateType] = date;

        if (dateType === DATE_TYPE.target && actualDate !== undefined && keyMilestonesEnabled) {
          targetMilestone[DATE_TYPE.actual] = actualDate;
        }

        break;
      }
    }

    setProject(updatedProject);
  };

  return (
    <GlobalS.FlexDiv style={{ alignItems: "top" }}>
      <MilestoneDateEditor
        data-test-id="target-date-milestone-edit"
        milestone={{ ...milestone, projectId: project.id }}
        intlId={"projectMilestoneTable.target"}
        datePropertyName={"targetDate"}
        onSaved={(projectMilestone) =>
          updateProjectContext(projectMilestone, DATE_TYPE.target)
        }
        disabled={
          !canUser(
            ProjectUserPermissions.EditMilestoneTargetDates,
            milestone
          ) || milestone.targetDateLocked
        }
      />
      <MilestoneDateEditor
        data-test-id="target-date-milestone-edit"
        milestone={{ ...milestone, projectId: project.id }}
        intlId={
          keyMilestonesEnabled
            ? "projectMilestoneTable.actualCurrent"
            : "projectMilestoneTable.actual"
        }
        datePropertyName={"actualDate"}
        disabled={
          !canUser(ProjectUserPermissions.EditMilestoneActualDates, milestone)
        }
        onSaved={(projectMilestone) =>
          updateProjectContext(projectMilestone, DATE_TYPE.actual)
        }
      />
      <S.StyledSpacer $width={32}></S.StyledSpacer>
    </GlobalS.FlexDiv>
  );
};

MilestoneDates.propTypes = {
  milestone: projectMilestoneType,
  canUser: func,
  project: object,
  setProject: func,
};
